// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1TAyP","col":"styles_col__Qmqvw"};